module.exports = __webpack_public_path__ + "static/media/hivis.cc0bee9b.webp";